<template>
  <vs-row>
    <vs-col vs-lg="6" vs-sm="12" class="p-2">
      <div class="light_grey_holder p-4">
        <vs-card class="cstm_vx_card text-center">
          <div slot="header">
            <h2 class="flex justify-center items-end">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48 48"
                width="48px"
                height="48px"
              >
                <path
                  fill="#FFC107"
                  d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
                />
                <path
                  fill="#FF3D00"
                  d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
                />
                <path
                  fill="#4CAF50"
                  d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
                />
                <path
                  fill="#1976D2"
                  d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
                />
              </svg>
              <span style="margin-left: -5px">oogle Access</span>
            </h2>
          </div>
          <div class="calender_switch_holder" v-if="googleConnectionStatus">
            <vs-tooltip text="Google Calendar" color="primary">
              <vs-switch
                class="vs-switch-primary"
                @click="connectGcal"
                v-model="gcalConnect"
              >
                <span slot="on">Sync</span>
                <span slot="off">Unsync</span>
              </vs-switch>
            </vs-tooltip>
          </div>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            width="48px"
            height="48px"
          >
            <path
              fill="#1e88e5"
              d="M38.59,39c-0.535,0.93-0.298,1.68-1.195,2.197C36.498,41.715,35.465,42,34.39,42H13.61 c-1.074,0-2.106-0.285-3.004-0.802C9.708,40.681,9.945,39.93,9.41,39l7.67-9h13.84L38.59,39z"
            />
            <path
              fill="#fbc02d"
              d="M27.463,6.999c1.073-0.002,2.104-0.716,3.001-0.198c0.897,0.519,1.66,1.27,2.197,2.201l10.39,17.996 c0.537,0.93,0.807,1.967,0.808,3.002c0.001,1.037-1.267,2.073-1.806,3.001l-11.127-3.005l-6.924-11.993L27.463,6.999z"
            />
            <path
              fill="#e53935"
              d="M43.86,30c0,1.04-0.27,2.07-0.81,3l-3.67,6.35c-0.53,0.78-1.21,1.4-1.99,1.85L30.92,30H43.86z"
            />
            <path
              fill="#4caf50"
              d="M5.947,33.001c-0.538-0.928-1.806-1.964-1.806-3c0.001-1.036,0.27-2.073,0.808-3.004l10.39-17.996 c0.537-0.93,1.3-1.682,2.196-2.2c0.897-0.519,1.929,0.195,3.002,0.197l3.459,11.009l-6.922,11.989L5.947,33.001z"
            />
            <path
              fill="#1565c0"
              d="M17.08,30l-6.47,11.2c-0.78-0.45-1.46-1.07-1.99-1.85L4.95,33c-0.54-0.93-0.81-1.96-0.81-3H17.08z"
            />
            <path
              fill="#2e7d32"
              d="M30.46,6.8L24,18L17.53,6.8c0.78-0.45,1.66-0.73,2.6-0.79L27.46,6C28.54,6,29.57,6.28,30.46,6.8z"
            />
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            width="48px"
            height="48px"
          >
            <rect width="22" height="22" x="13" y="13" fill="#fff" />
            <polygon
              fill="#1e88e5"
              points="25.68,20.92 26.688,22.36 28.272,21.208 28.272,29.56 30,29.56 30,18.616 28.56,18.616"
            />
            <path
              fill="#1e88e5"
              d="M22.943,23.745c0.625-0.574,1.013-1.37,1.013-2.249c0-1.747-1.533-3.168-3.417-3.168 c-1.602,0-2.972,1.009-3.33,2.453l1.657,0.421c0.165-0.664,0.868-1.146,1.673-1.146c0.942,0,1.709,0.646,1.709,1.44 c0,0.794-0.767,1.44-1.709,1.44h-0.997v1.728h0.997c1.081,0,1.993,0.751,1.993,1.64c0,0.904-0.866,1.64-1.931,1.64 c-0.962,0-1.784-0.61-1.914-1.418L17,26.802c0.262,1.636,1.81,2.87,3.6,2.87c2.007,0,3.64-1.511,3.64-3.368 C24.24,25.281,23.736,24.363,22.943,23.745z"
            />
            <polygon
              fill="#fbc02d"
              points="34,42 14,42 13,38 14,34 34,34 35,38"
            />
            <polygon
              fill="#4caf50"
              points="38,35 42,34 42,14 38,13 34,14 34,34"
            />
            <path
              fill="#1e88e5"
              d="M34,14l1-4l-1-4H9C7.343,6,6,7.343,6,9v25l4,1l4-1V14H34z"
            />
            <polygon fill="#e53935" points="34,34 34,42 42,34" />
            <path fill="#1565c0" d="M39,6h-5v8h8V9C42,7.343,40.657,6,39,6z" />
            <path fill="#1565c0" d="M9,42h5v-8H6v5C6,40.657,7.343,42,9,42z" />
          </svg>
          <p class="mt-4 mb-4">
            To access Google Drive and Google Calendar please synchronize your
            google account with the portal.
          </p>
          <button
            class="google_signup_btn outline_primary mx-auto mt-0"
            @click.prevent="googleConnect()"
            v-if="!googleConnectionStatus"
          >
            <span>Connect</span>
          </button>
          <button
            class="google_signup_btn outline_danger mx-auto mt-0"
            @click.prevent="googleDisconnect()"
            v-else
          >
            <span>Disconnect</span>
          </button>
        </vs-card>
      </div>
    </vs-col>
    <vs-col vs-lg="6" vs-sm="12" class="p-2">
      <div class="light_grey_holder p-4">
        <Quickbook />
      </div>
    </vs-col>
    <vs-col vs-w="12" class="p-2">
      <div class="light_grey_holder p-4">
        <PaymentGateways />
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
import Quickbook from '@/views/pages/user-settings/UserSettingsQuickbook.vue'
import PaymentGateways from '@/views/pages/user-settings/UserSettingsPaymentsGateway.vue'

import {
  googleConnectAuth,
  getGoogleStatus,
  disconnectGoogleApi,
  googleCalConnect
} from '@/api/authorization'

export default {
  components: {
    Quickbook,
    PaymentGateways
  },
  data () {
    return {
      gcalConnect: false,
      role_permission: parseInt(localStorage.getItem('role_permission')),
      userSettings: null,
      school_address: [],
      googleConnectionStatus: false,
      currTabIndex: 0
    }
  },
  created () {
    this.fetchGoogleConnectionStatus()
  },
  methods: {
    async connectGcal () {
      try {
        const payload = {
          auto_sync: !this.gcalConnect
        }
        await googleCalConnect(localStorage.getItem('customer_id'), payload)
        this.showSuccessMessage(
          'Connected',
          `Google calendar ${
            payload.auto_sync ? 'Connected' : 'Disconnected'
          } successfully`,
          'success'
        )
      } catch (e) {
        //
      }
    },
    async googleConnect () {
      try {
        const { data } = await googleConnectAuth(
          localStorage.getItem('customer_id')
        )
        window.open(data.data.auth_url, '_self')
      } catch (error) {
        console.warn(error)
      }
    },
    async googleDisconnect () {
      try {
        await disconnectGoogleApi(localStorage.getItem('customer_id'))

        this.googleConnectionStatus = false
        this.showSuccessMessage(
          'Disconnect',
          'Disconnect from Google Successfully',
          'success'
        )
      } catch (error) {
        console.warn(error)
      }
    },
    async fetchGoogleConnectionStatus () {
      try {
        const { data } = await getGoogleStatus(
          localStorage.getItem('customer_id')
        )
        this.googleConnectionStatus = data.data.status
        if (this.googleConnectionStatus) {
          this.gcalConnect = data.data.auto_sync === 1
        }
        console.log(data.staus)
      } catch (error) {
        console.warn(error)
      }
    }
  }
}
</script>
<style>
.calender_switch_holder{
  position: absolute;
  left: 480px;
  top: 50px;
}
</style>